import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`text-sm font-bold uppercase tracking-[0.2em] ${
      light ? "text-amber-400" : "text-blue-600"
    }`}
  >
    {children}
  </p>
);
